// extracted by mini-css-extract-plugin
module.exports = {"ctas":"CapsuleBannerCtas_ctas__bwp8H","column":"CapsuleBannerCtas_column__Zj7eu","cta":"CapsuleBannerCtas_cta__aB7_r","hidden":"CapsuleBannerCtas_hidden__Qrot8"};